import React from 'react';

const WrongIcon: React.FC = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 0.832031C15.0626 0.832032 19.167 4.93641 19.167 9.99902C19.167 15.0616 15.0626 19.166 10 19.166C4.93739 19.166 0.833008 15.0616 0.833008 9.99902C0.833008 4.93641 4.93739 0.832031 10 0.832031ZM10 8.70605L7.62598 6.33203L6.33301 7.625L8.70703 9.99902L6.33301 12.373L7.62598 13.666L10 11.292L12.374 13.666L13.667 12.373L12.4795 11.1865L11.293 9.99902L13.667 7.625L12.374 6.33203L10 8.70605Z"
        fill="#DC3A44"
      />
    </svg>
  );
};

export default WrongIcon;
